export const namespace = 'supplies';
